import router from '@/router'
import { useUserStore } from '@/stores/user'
import { useErrorStore } from '@/stores/error'
import { getFieldMessage } from '@/utils/message'

/**
 * localStorageとsessionStorageのユーザIDを比較し、他ユーザログイン中の場合ErrorPageへリダイレクトする
 * @returns 他ユーザでログインされていた場合true、そうでなければfalse
 */
export async function checkAndRedirectIfAnotherUserLoggedIn(): Promise<boolean> {
  const localLoginName = localStorage.getItem('loginId')
  const loginName = useUserStore().userInfo?.login_name

  if (loginName && localLoginName && loginName !== localLoginName) {
    useUserStore().clearUserInfo()
    useErrorStore().setError('', getFieldMessage('anotheruserlogged912'))
    await router.push({ name: 'ErrorPage' })
    return true
  }
  return false
}
